import React from 'react';

import NavigationButton from './navigation-button';
import SearchButton from './search-button';
import CartLink from './cart-link';
import SearchForm from './search-form';

interface Props {
  logoURL: string;
}

const MobileHeader: React.FC<Props> = (props) => {
  const { logoURL } = props;

  return (
    <header className="MobileHeader">
      <div className="MobileHeader-content">
        <NavigationButton />

        <a href="/" className="MobileHeader-logo" aria-label="House Industries">
          <img src={logoURL} alt="Company Logo" />
        </a>

        <div className="MobileHeader-right">
          <SearchButton />

          <a href="/account" className="MobileHeader-account" aria-label="Account"></a>

          <CartLink />
        </div>
      </div>

      <SearchForm mobile />
    </header>
  );
};

export default MobileHeader;
